import React from 'react';
import Navbar from '../components/layout/Navbar';
import AddFromAnExistingContactForm from '../components/layout/AddFromAnExistingContactForm';
import { useParams } from 'react-router-dom';

function AddNewRecordFromContactPage() {
  let { selectName } = useParams();

  return (
    <>
      <div>
        <Navbar />
        <div className='container'>
          <br />
          <h2>Add a new Contact for this Person</h2>
          <div style={{ textAlign: 'center' }}></div>
          <AddFromAnExistingContactForm updateName={selectName} />
        </div>
      </div>
    </>
  );
}

export default AddNewRecordFromContactPage;
